import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { pick, isEmpty } from "lodash";

import MyAccountLayout from "./MyAccountLayout";
import { apiGet, apiPost, apiPut } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import { toast } from "react-toastify";
import { levelMap } from "../../Utils/Constant";
import ChangePasswordModal from "../User/ChangePassword";

const AccountSummary = () => {
  const { id } = useParams();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);
  const setComission = useContextSelector(
    AuthContext,
    (ctx) => ctx.setComission,
  );
  const [summaryData, setSummaryData] = useState({});
  const [isLoader, setLoader] = useState(false);

  const [changePassword, setChangePassword] = useState(false);
  const [change, setChange] = useState(false);
  const [changeType, setChangeType] = useState("");
  const [mobileEdit, setMobileEdit] = useState(false);
  const [whatsAppEdit, setWhatsAppEdit] = useState(false);
  const changePasswordToggle = () => setChangePassword(!changePassword);
  const getSummary = async () => {
    const url = `${apiPath.userProfile}?user_id=${!isEmpty(id) ? id : user?._id}`;
    const { status, data: response_users } = await apiGet(url);
    if (status === 200 && response_users.success) {
      setSummaryData(response_users.results);
      setComission?.(response_users.results.commission);
    }
  };

  useEffect(() => {
    if (!isEmpty(id)) {
      getSummary();
    }
  }, [id]);

  const {
    register: registerLimit,
    unregister: unregisterLimit,
    handleSubmit: handleSubmitLimit,
    formState: { errors: limitErrors },
    reset: resetLimit,
  } = useForm();

  const openLimitModal = (type) => {
    setChangeType(type);
    setChange(true);
    if (type === "exposure") {
      registerLimit("exposureLimit", { required: "Please enter exposure" });
      unregisterLimit("commission");
    } else {
      registerLimit("commission", { required: "Please enter commission" });
      unregisterLimit("exposureLimit");
    }
  };

  const onChangeLimit = async (request) => {
    setLoader(true);
    try {
      const requestData = { user_id: id, password: request.password };
      if (changeType === "exposure")
        requestData.exposure_limit = request.exposureLimit;
      else requestData.commission = request.commission;

      const { status, data: response_users } = await apiPost(
        changeType === "exposure"
          ? apiPath.updateExposure
          : apiPath.updateCommission,
        requestData,
      );
      if (status === 200 && response_users.success) {
        toast.success(response_users.message);
        resetLimit();
        setChange(false);
        getSummary();
      } else {
        toast.error(response_users.message);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message);
    } finally {
      setLoader(false);
    }
  };

  /* ------------------------------ Phone edit ------------------------------ */
  const {
    register: registerPhone,
    handleSubmit: handleSubmitPhone,
    reset: resetPhone,
  } = useForm();

  const onUpdatePhone = async (request) => {
    const phone = String(request?.phone || "");
    if (!phone) {
      toast.error("Please enter phone number");
      return;
    }
    const { status, data: response_users } = await apiPut(
      apiPath.profileUpdate + "/" + id,
      {
        phone: Number(phone),
        first_name: summaryData?.firstName,
        last_name: summaryData?.lastName,
        email: summaryData?.email,
      },
    );
    if (status === 200 && response_users.success) {
      toast.success(response_users.message);
      getSummary();
      setMobileEdit(false);
      resetPhone();
    } else {
      toast.error(response_users.message);
    }
  };

  /* ---------------------------- WhatsApp edit ---------------------------- */
  const {
    register: registerWhatsApp,
    handleSubmit: handleSubmitWhatsApp,
    reset: resetWhatsApp,
  } = useForm();

  const onUpdateWhatsApp = async (request) => {
    const whatsAppNumber = String(request?.whatsAppNumber || "");
    if (!whatsAppNumber) {
      toast.error("Please enter WhatsApp number");
      return;
    }
    const { status, data: response_users } = await apiPut(
      apiPath.profileUpdate + "/" + id,
      {
        whatsAppNumber: Number(whatsAppNumber),
        first_name: summaryData?.firstName,
        last_name: summaryData?.lastName,
        email: summaryData?.email,
      },
    );
    if (status === 200 && response_users.success) {
      toast.success(response_users.message);
      getSummary();
      setWhatsAppEdit(false);
      resetWhatsApp();
    } else {
      toast.error(response_users.message);
    }
  };
  const onSubmit = async (request) => {
    const { status, data: response_users } = await apiPost(
      apiPath.changePassword + (!isEmpty(id) ? `?user_id=${id}` : ""),
      pick(request, ["oldPassword", "newPassword"]),
    );
    if (status === 200) {
      if (response_users.success) {
        setChangePassword();
        toast.success(response_users.message);
      } else {
        toast.error(response_users.message);
      }
    }
  };
  const canEditLimits =
    summaryData?.userType === "user" && ["owner", "sub_owner","super_admin", "agent"].includes(user?.userType);

  return (
    <MyAccountLayout>
      <div id="report" className="col-center report">
        {!isEmpty(id) && (
          <>
            <h2>Account Summary</h2>
            <ul style={{ marginBottom: "8px" }} className="acc-info">
              <li className="user">
                <span
                  className={`Bdlevel ${levelMap[summaryData?.userType]}`}
                />{" "}
                {summaryData?.username}
              </li>
            </ul>

            <table className="table01">
              <tbody>
                <tr>
                  <th width="20%" className="align-L">
                    Wallet
                  </th>
                  <th width="25%">Available to Bet</th>
                  <th>Funds available to withdraw</th>
                  <th width="25%">Current exposure</th>
                </tr>
                <tr>
                  <td className="align-L">Main wallet</td>
                  <td>{summaryData?.totalCoins}</td>
                  <td>{summaryData?.totalCoins}</td>
                  <td>{summaryData?.exposure}</td>
                </tr>
              </tbody>
            </table>

            <h2>Profile</h2>
            <div className="event-left">
              <div className="profile-wrap">
                <h3>About {summaryData?.username}</h3>
                <dl>
                  <dt>Fullname</dt>
                  <dd>{summaryData?.firstName || "--"}</dd>

                  <dt>Email</dt>
                  <dd>{summaryData?.email || "--"}</dd>

                  <dt>Time Zone</dt>
                  <dd>{summaryData?.timeZone || "--"}</dd>

                  <dt>Password</dt>
                  <dd>
                    <span>***********************</span>
                    <a
                      href="#"
                      className="favor-set"
                      onClick={(e) => {
                        e.preventDefault();
                        setChangePassword(true);
                      }}
                    >
                      Edit
                    </a>
                  </dd>
                </dl>
              </div>

              <div className="profile-wrap">
                <h3>Contact Details</h3>
                <dl>
                  <dt>Phone Number</dt>
                  <dd>
                    {summaryData?.phone || "--"}
                    {/* <a
                      href="#"
                      className="favor-set"
                      onClick={(e) => {
                        e.preventDefault();
                        resetPhone({ phone: summaryData?.phone || "" });
                        setMobileEdit(true);
                      }}
                    >
                      Edit
                    </a> */}
                  </dd>

                  <dt>WhatsApp Number</dt>
                  <dd>
                    {summaryData?.whatsAppNumber || "--"}
                    {/* <a
                      href="#"
                      className="favor-set"
                      onClick={(e) => {
                        e.preventDefault();
                        resetWhatsApp({
                          whatsAppNumber: summaryData?.whatsAppNumber || "",
                        });
                        setWhatsAppEdit(true);
                      }}
                    >
                      Edit
                    </a> */}
                  </dd>
                </dl>
              </div>

              <div className="profile-wrap">
                <h3>Upline WhatsApp Number</h3>
                <dl>
                  <dt>Phone Number</dt>
                  <dd>
                    {summaryData?.[summaryData?.createdBy]?.phone || "--"}
                  </dd>
                  <dt>WhatsApp Number</dt>
                  <dd>
                    {summaryData?.[summaryData?.createdBy]?.whatsAppNumber ||
                      "--"}
                  </dd>
                </dl>
              </div>
            </div>

            {canEditLimits && (
              <div className="event-right">
                <div className="profile-wrap">
                  <h3>Contact Details</h3>
                  <dl>
                    <dt>Primary Number</dt>
                    <dd>{summaryData?.phone}</dd>
                  </dl>
                </div>

                <div className="profile-wrap">
                  <h3>Limits &amp; Commission</h3>
                  <dl>
                    <dt>Exposure Limit</dt>
                    <dd id="mainwalletExposureLimit">
                      <span>{summaryData?.exposureLimit}</span>
                      <a
                        href="#"
                        className="favor-set"
                        onClick={(e) => {
                          e.preventDefault();
                          openLimitModal("exposure");
                        }}
                      >
                        Edit
                      </a>
                    </dd>
                  </dl>
                  <dl>
                    <dt>Commission</dt>
                    <dd id="mainwalletExposureLimit">
                      <span>{summaryData?.commission}</span>
                      <a
                        href="#"
                        className="favor-set"
                        onClick={(e) => {
                          e.preventDefault();
                          openLimitModal("commission");
                        }}
                      >
                        Edit
                      </a>
                    </dd>
                  </dl>
                </div>
              </div>
            )}

            {/* Change Commission / Exposure */}
            {change && (
              <div
                id="createModal"
                className="pop_bg"
                style={{ height: "100%", width: "100%" ,display:change?"block":""}}
              >
                <div className="pop_box pop_refer">
                  <a
                    href="#"
                    className="close_pop"
                    onClick={(e) => {
                      e.preventDefault();
                      setChange(false);
                      resetLimit();
                    }}
                  >
                    close_pop
                  </a>
                  <form noValidate onSubmit={handleSubmitLimit(onChangeLimit)}>
                    <div className="modal-header">
                      <h3>
                        {changeType === "exposure"
                          ? "Change Exposure"
                          : "Change Commission"}
                      </h3>
                    </div>
                    <div className="modal-content">
                      <dl className="form_list">
                        {changeType === "exposure" ? (
                          <>
                            <dt>Exposure Limit</dt>
                            <dd>
                              <input
                                type="text"
                                placeholder="Enter"
                                {...registerLimit("exposureLimit", {
                                  required: "Please enter exposure",
                                })}
                              />
                              <span className="must">＊</span>
                              {limitErrors?.exposureLimit && (
                                <span className="error-text">
                                  {limitErrors.exposureLimit.message}
                                </span>
                              )}
                            </dd>
                          </>
                        ) : (
                          <>
                            <dt>Commission</dt>
                            <dd>
                              <input
                                type="text"
                                placeholder="Enter"
                                {...registerLimit("commission", {
                                  required: "Please enter commission",
                                })}
                              />
                              %<span className="must">＊</span>
                              {limitErrors?.commission && (
                                <span className="error-text">
                                  {limitErrors.commission.message}
                                </span>
                              )}
                            </dd>
                          </>
                        )}

                        <dt>Password</dt>
                        <dd>
                          <input
                            type="password"
                            placeholder="Enter"
                            {...registerLimit("password", {
                              required: "Please enter your password",
                            })}
                          />
                          <span className="must">＊</span>
                          {limitErrors?.password && (
                            <span className="error-text">
                              {limitErrors.password.message}
                            </span>
                          )}
                        </dd>

                        <dd>
                          <button
                            type="submit"
                            className="btn-send"
                            disabled={isLoader}
                          >
                            Change
                          </button>
                        </dd>
                      </dl>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Edit Phone */}
            {mobileEdit && (
              <div
                id="createModal"
                className="pop_bg"
                style={{ height: "100%", width: "100%" }}
              >
                <div className="pop_box pop_refer">
                  <a
                    href="#"
                    className="close_pop"
                    onClick={(e) => {
                      e.preventDefault();
                      setMobileEdit(false);
                      resetPhone();
                    }}
                  >
                    close_pop
                  </a>
                  <form noValidate onSubmit={handleSubmitPhone(onUpdatePhone)}>
                    <div className="modal-header">
                      <h3>Edit Phone Number</h3>
                    </div>
                    <div className="modal-content">
                      <dl className="form_list">
                        <dt>Phone Number</dt>
                        <dd>
                          <input
                            type="text"
                            placeholder="Enter"
                            defaultValue={summaryData?.phone || ""}
                            {...registerPhone("phone", {
                              required: "Please enter phone number",
                            })}
                          />
                          <span className="must">＊</span>
                        </dd>
                        <dd>
                          <button type="submit" className="btn-send">
                            Update
                          </button>
                        </dd>
                      </dl>
                    </div>
                  </form>
                </div>
              </div>
            )}

            {/* Edit WhatsApp */}
            {whatsAppEdit && (
              <div
                id="createModal"
                className="pop_bg"
                style={{ height: "100%", width: "100%" }}
              >
                <div className="pop_box pop_refer">
                  <a
                    href="#"
                    className="close_pop"
                    onClick={(e) => {
                      e.preventDefault();
                      setWhatsAppEdit(false);
                      resetWhatsApp();
                    }}
                  >
                    close_pop
                  </a>
                  <form
                    noValidate
                    onSubmit={handleSubmitWhatsApp(onUpdateWhatsApp)}
                  >
                    <div className="modal-header">
                      <h3>Edit WhatsApp Number</h3>
                    </div>
                    <div className="modal-content">
                      <dl className="form_list">
                        <dt>WhatsApp Number</dt>
                        <dd>
                          <input
                            type="text"
                            placeholder="Enter"
                            defaultValue={summaryData?.whatsAppNumber || ""}
                            {...registerWhatsApp("whatsAppNumber", {
                              required: "Please enter WhatsApp number",
                            })}
                          />
                          <span className="must">＊</span>
                        </dd>
                        <dd>
                          <button type="submit" className="btn-send">
                            Update
                          </button>
                        </dd>
                      </dl>
                    </div>
                  </form>
                </div>
              </div>
            )}
          </>
        )}

        {isEmpty(id) && (
          <>
            <h2>Account Summary</h2>
            <div style={{ marginBottom: "15px" }} className="white-wrap">
              <dl className="head-balance">
                <dt style={{ lineHeight: "1.42857143" }}>Your Balances</dt>
                <dd style={{ marginBottom: "0" }} id="yourBalance">
                  <span>USD</span> {user?.totalCoins ?? "0.00"}
                </dd>
              </dl>
            </div>
          </>
        )}
      </div>
      <ChangePasswordModal
        isOpen={changePassword}
        onClose={changePasswordToggle}
        onSubmit={onSubmit}
      />
    </MyAccountLayout>
  );
};

export default AccountSummary;
